type RequestIdleCallbackHandle = NodeJS.Timeout
type RequestIdleCallbackOptions = {
  timeout: number
}
type RequestIdleCallbackDeadline = {
  readonly didTimeout: boolean
  timeRemaining: () => number
}

type RequestIdleCallbackCallback = (deadline: RequestIdleCallbackDeadline) => void

type RequestIdleCallback = (
  callback: RequestIdleCallbackCallback,
  opts?: RequestIdleCallbackOptions
) => RequestIdleCallbackHandle

type CancelIdleCallback = (handle: RequestIdleCallbackHandle) => void
declare global {
  interface Window {
    [key: string]: any
    requestIdleCallback: RequestIdleCallback
    cancelIdleCallback: CancelIdleCallback
  }
}

/* eslint-disable compat/compat */
export const requestIdleCallbackShim: RequestIdleCallback =
  typeof window !== 'undefined' && 'requestIdleCallback' in window
    ? window.requestIdleCallback
    : requestIdleCallbackFallback

export const cancelIdleCallbackShim: CancelIdleCallback =
  typeof window !== 'undefined' && 'cancelIdleCallback' in window
    ? window.cancelIdleCallback
    : clearTimeout

function requestIdleCallbackFallback(
  cb: RequestIdleCallbackCallback,
  opts: RequestIdleCallbackOptions
): RequestIdleCallbackHandle {
  const start = Date.now()
  const timeout = (opts && opts.timeout) || 50
  return setTimeout(cb, 1, {
    didTimeout: false,
    timeRemaining: () => Math.max(0, timeout - (Date.now() - start))
  })
}
